import React from "react";
import Tooltip from "./tooltip";

const InputField = ({
  label = "",
  name,
  placeholder,
  type,
  value,
  onChange,
  keyboardEvent = {},
  children = null,
  max = null,
  as = "li",
  className = "",
  tooltip = null,
  readOnly = false,
}) => {
  const Element = as;
  const isList = as === "li";

  const renderValue = () => {
    if (name === "quantity") return String(value) === "-1" ? "무제한" : formatNumber(value);
    if (type === "number") return value ? formatNumber(value) : "";
    return value;
  };

  const input = (
    <input
      type="text"
      name={name}
      value={renderValue()}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={readOnly}
      {...keyboardEvent}
      maxLength={max}
    />
  );

  return (
    <Element className={`${name} ${className}`}>
      {isList ? (
        <>
          {label &&
            (tooltip ? (
              <Tooltip label={label} tooltip={tooltip} />
            ) : (
              <span className="tit">{label}</span>
            ))}
          <div className="cont">
            {input}
            {children && <div className="extra-content">{children}</div>}
          </div>
        </>
      ) : (
        <>
          {input}
          {children}
        </>
      )}
    </Element>
  );
};

export default InputField;
